import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBatchesByProductAndLocation } from "../../actions/wineryBatchesActions"
import {Table} from "../Table/Table"
const BatchesList = ({ match }) => {
    const dispatch = useDispatch();
    let ProductId = match.params.ProductId;
    let LocationId = match.params.LocationId;
    useEffect(() => {
        dispatch(getBatchesByProductAndLocation(ProductId, LocationId));
    }, []);
    const { wineryBatchesList, isLoadingWineryBatches } = useSelector((state) => state.wineryBatchesAdmin);
    return (
        <div>
            <Table>
                <thead>
                    <tr>
                        <th>Id Lote</th>
                        <th>Stock</th>
                        <th>Fecha de expedición</th>
                        <th>Fecha de expiración</th>
                    </tr>
                </thead>
                <tbody>
                    {!isLoadingWineryBatches && wineryBatchesList?.batches.map((element) => (
                        <tr key={element._id}>
                            <td>{element._id}</td>
                            <td>{element.quantityStock}</td>
                            <td>{new Date(element.expeditionDate).toLocaleDateString()}</td>
                            <td>{new Date(element.expirationDate).toLocaleDateString()}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    )
}

export default BatchesList
